import { useState, ReactNode, FunctionComponent } from "react";
import {
  StyledDropdownItem,
  StyledDropdownMenuStyled,
  StyledDropdownToggle,
  StyledDropdown,
  StyledDropdownShim,
} from "./dropdown.styles";

export interface DropdownItem {
  text: string;
  onClick: () => void;
}

interface DropdownProps {
  label: ReactNode;
  items: DropdownItem[];
  className?: string;
}

const Dropdown: FunctionComponent<DropdownProps> = ({
  label,
  items,
  className,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <StyledDropdown className={className}>
      <StyledDropdownToggle onClick={() => setOpen((o) => !o)}>
        {label}
      </StyledDropdownToggle>
      {open && (
        <>
          <StyledDropdownShim onClick={() => setOpen(false)} />
          <StyledDropdownMenuStyled>
            {items.map((item) => (
              <StyledDropdownItem
                key={item.text}
                onClick={() => {
                  // actual event
                  item.onClick();

                  // dropdown close
                  setOpen(false);
                }}
              >
                {item.text}
              </StyledDropdownItem>
            ))}
          </StyledDropdownMenuStyled>
        </>
      )}
    </StyledDropdown>
  );
};

export default Dropdown;
